import React, { InputHTMLAttributes, useState } from "react";
import styled from "styled-components";
import Typography from "../typography";
import { Colors } from "../../utils/colors";

interface IProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  required?: boolean;
  status?: string; //error
}
const PasswordInput = ({
  label,
  required,
  status = "default",
  ...rest
}: IProps) => {
  const [focused, setFocused] = useState(false);
  const [passwordType, setPasswordType] = useState(true);
  return (
    <Container>
      {label && (
        <Typography color="#CDCDCD" weight="medium" mb="0.4" align="left">
          {label}
          {required && "*"}
        </Typography>
      )}
      <InputContainer status={status} focused={focused ? "true" : "false"}>
        <Input
          status={status}
          {...rest}
          onFocus={() => {
            setFocused(true);
          }}
          type={passwordType ? "password" : "text"}
          onBlur={() => setFocused(false)}
        />
        <Eye
          onClick={() => {
            setPasswordType(!passwordType);
          }}
        >
          {passwordType ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 24 24"
            >
              <g fill="none" stroke="currentColor" stroke-width="1.5">
                <path
                  d="M3.275 15.296C2.425 14.192 2 13.639 2 12c0-1.64.425-2.191 1.275-3.296C4.972 6.5 7.818 4 12 4s7.028 2.5 8.725 4.704C21.575 9.81 22 10.361 22 12c0 1.64-.425 2.191-1.275 3.296C19.028 17.5 16.182 20 12 20s-7.028-2.5-8.725-4.704Z"
                  opacity="0.5"
                />
                <path d="M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0Z" />
              </g>
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="M2.69 6.705a.75.75 0 0 0-1.38.59zm12.897 6.624l-.274-.698zm7.102-6.034a.75.75 0 0 0-1.378-.59zM19 11.13l-.513-.547zm-7 2.121c-3.224 0-5.539-1.605-7.075-3.26a13.6 13.6 0 0 1-1.702-2.28a12 12 0 0 1-.507-.946l-.022-.049l-.004-.01l-.001-.001L2 7l-.69.296h.001l.001.003l.003.006l.04.088q.039.088.117.243c.103.206.256.496.462.841c.41.69 1.035 1.61 1.891 2.533C5.54 12.855 8.224 14.75 12 14.75zm3.313-.62c-.97.383-2.071.62-3.313.62v1.5c1.438 0 2.725-.276 3.862-.723zM22 7l-.69-.296h.001v.002l-.007.013l-.028.062a12 12 0 0 1-.64 1.162a13.3 13.3 0 0 1-2.15 2.639l1.027 1.094a14.8 14.8 0 0 0 3.122-4.26l.039-.085l.01-.024l.004-.007v-.003h.001v-.001zm-3.513 3.582c-.86.806-1.913 1.552-3.174 2.049l.549 1.396c1.473-.58 2.685-1.444 3.651-2.351z"
              />
              <path
                fill="currentColor"
                d="M12.75 14a.75.75 0 0 0-1.5 0zm3.466-1.08a.75.75 0 1 0-1.257.818zm-7.175.818a.75.75 0 0 0-1.257-.818zm-2.67 1.353a.75.75 0 0 0 1.258.818zm13.16-4.492a.75.75 0 1 0-1.061 1.06zm.439 2.56a.75.75 0 1 0 1.06-1.06zM11.25 16.5a.75.75 0 0 0 1.5 0zm5.121-.59a.75.75 0 1 0 1.258-.819zm-10.84-4.25a.75.75 0 1 0-1.061-1.061zm-2.561.439a.75.75 0 1 0 1.06 1.06zm4.814.82l-1.413 2.172l1.258.818l1.412-2.171zm10.686-1.26l1.5 1.5l1.06-1.06l-1.5-1.5zM11.25 14v2.5h1.5V14zm3.709-.262l1.412 2.171l1.258-.818l-1.413-2.171zm-10.49-3.14l-1.5 1.5L4.03 13.16l1.5-1.5z"
                opacity="0.5"
              />
            </svg>
          )}
        </Eye>
      </InputContainer>
    </Container>
  );
};

export default PasswordInput;

const Container = styled.div`
  position: relative;
`;

const InputContainer = styled.div<{ status?: string; focused?: string }>`
  width: 100%;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid
    ${(props) =>
      props.focused === "true"
        ? Colors.primary
        : props.status === "error"
        ? Colors.danger
        : Colors.grey500};
  border-radius: 0.8rem;
  transition: ease all 0.2s;
`;

const Input = styled.input<{ status?: string }>`
  font-family: "Switzer", sans-serif;
  width: 90%;
  outline: none;
  background: none;
  border: none;
  color: ${Colors.white200};
  font-family: "Inter", sans-serif;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.6rem;
  &::placeholder {
    color: ${Colors.grey500};
  }
`;

const Eye = styled.div`
  width: 2rem;
  cursor: pointer;
  margin-right: 1rem;
`;
